import { render, staticRenderFns } from "./PrivateMemberTalk.vue?vue&type=template&id=0ea4cee6&scoped=true&"
import script from "./PrivateMemberTalk.vue?vue&type=script&lang=js&"
export * from "./PrivateMemberTalk.vue?vue&type=script&lang=js&"
import style0 from "./PrivateMemberTalk.vue?vue&type=style&index=0&id=0ea4cee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea4cee6",
  null
  
)

export default component.exports